import { ModuleWithProviders } from '@angular/core';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const storeDevtoolsModule: ModuleWithProviders<StoreDevtoolsModule>[] = [
  StoreDevtoolsModule.instrument({
    maxAge: 25,
    name: 'Easylot',
  }),
];
